import React, { Component, Fragment } from 'react';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

class PermissionsTable extends Component
{
	constructor (props) {
		super(props);

		this.state = {
			dirty: false,
			saving: false
		}

		const that = this;

		let tokens = {};
		Object.keys(this.props.user).forEach(function (ability) {
			tokens[ability] = true;
		});
		this.state.tokens = tokens;

		this.onSubmitChanges = this.onSubmitChanges.bind(this);

		this.uniqueActionList = this.getUniqueActionsList(props.server.actions);
	}

	diffCurrentStateWithOriginal () {
		return JSON.stringify(this.props.user) !== JSON.stringify(this.getActiveTokens(this.state.tokens));
	}

	getActiveTokens (tokens) {
		const that = this;
		return Object.keys(tokens).filter((k) => tokens[k]);
	}

	onSubmitChanges = (e) => {
		const that = this;

		this.props.savingBeacon(true);

		let tokensAsArray = Object.filter(this.state.tokens, function (token) {
			return token === true;
		});

		this.props.onSaveChanges(Object.keys(tokensAsArray)).then(function () {
			that.props.dirtyBeacon(false);
			that.props.savingBeacon(false);
		});
	}

	onPermissionChange = (token) => (e) => {
		const that = this;
		let tokens = this.state.tokens;
		tokens[token] = (e.target.checked === true);
		this.setState({ tokens: tokens }, function () {
			if (that.diffCurrentStateWithOriginal()) {
				that.props.dirtyBeacon(true);
			} else {
				that.props.dirtyBeacon(false);
			}
		});
	}

	getUniqueActionsList (actionsToFilter) {
		let actions = [];
		const allowedActions = actionsToFilter.filter(action => ["translate", "validate", "read"].indexOf(action.name) > -1);
		actions = allowedActions.filter(function (a) {
			if (actions[a.name]) {
				return false;
			}
			actions[a.name] = a;
			return true;
		});

		return actions;
	}

	render () {
		const that = this;

		return (
			<Fragment>
				<div className="table-container">
					<table className="table is-fullwidth" style={{pointerEvents: (this.state.saving) ? 'none' : 'auto'}}>
						<thead>
							<tr>
								<th>Locale</th>
								{(
									that.uniqueActionList.map(function (action) {
										return (
											<th style={{textAlign: 'center'}} key={"permissions.table.header.user." + action.name}>
												{action.name.capitalize()}
												<span style={{marginLeft: '5px'}} data-balloon={action.description} data-balloon-pos="up">
								          <FontAwesomeIcon icon="info-circle" />
								        </span>
											</th>
										);
									})
								)}
							</tr>
						</thead>
						<tbody>
							{(
								Object.keys(this.props.server.tokens).map(key => {
									const entity = that.props.server.tokens[key];
									return (
										<tr key={"permissions.row.table.user." + key}>
											<td style={{fontWeight: 600}}>{key}</td>
											{(
												Object.keys(entity).map(ak => {
													const canIdoThat = (that.props.user.hasOwnProperty(entity[ak].key));
													return (
														<td title={key} className={this.state.tokens[entity[ak].key] ? 'allowed-perm' : 'not-allowed-perm'} style={{textAlign: 'center'}} key={"permissions.table.checkbox.user." + key + "." + entity[ak].key}>
															<div className="pretty p-default p-curve p-thick">
																<input type="checkbox" onChange={this.onPermissionChange(entity[ak].key)} value={that.state.tokens[entity[ak].key]} defaultChecked={canIdoThat} />
										            <div className="state p-success">
										              <label></label>
										            </div>
															</div>
														</td>
													);
												})
											)}
										</tr>
									);
								})
							)}
						</tbody>
					</table>
				</div>
			</Fragment>
		);
	}
}

export default PermissionsTable;



// WEBPACK FOOTER //
// ./src/Components/Users/PermissionsTable.js